import React from 'react';

import HomecardImage from '../common/HomecardImage';

import HomecardContent from './components/HomecardContent';
import HomecardDescription from './components/HomecardDescription';
import HomecardWrapper from './components/HomecardWrapper';

const Homecard = props => (
  <HomecardWrapper
    {...props}
    renderImage={componentProps => <HomecardImage {...componentProps} />}
    renderContent={componentProps => <HomecardContent {...componentProps} />}
    renderDescription={componentProps => (
      <HomecardDescription {...componentProps} />
    )}
  />
);

export default Homecard;
